/* AMBRA — zakładka boczna (uniwersalna) (lp-tab15) v2.1 — logika. Ustawienia przychodzą z sekcji (JSON w data-lp-tab15-cfg).
   Kilka instancji naraz: każda ma własny klucz kampanii → własny stan w localStorage „lp_tab15:<klucz>” =
   { until, visits, countedVisit, clicked, last, visitStart, hideVisit, signed }.
   Wspólne dla wszystkich: „lp_tab15_sm” = { closed } — pop-up SALESmanago był wyświetlony i zamknięty w tej przeglądarce.
   Zapis SM rozpoznajemy po kluczu „_smwesform-…”; wysłanie formularza w okienku = „signed” dla tego klucza.
   Wykluczenia JS: zapisany, ukryty (×/limit wizyt), znany kontakt SM (cookie smclient), znacznik kupującego (lp_buyer z piksela). */
(function () {
  'use strict';

  var VISIT_GAP = 30 * 60 * 1000;
  var DAY = 864e5;
  var SM_KEY = 'lp_tab15_sm';
  var FONTS = 'https://fonts.googleapis.com/css2?family=Jost:wght@400;600;700&family=Playfair+Display:wght@700&display=swap';
  var timers = window.__lpTab15Timers = window.__lpTab15Timers || {};

  function lsGet(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
  function read(k) { try { return JSON.parse(lsGet(k)) || {}; } catch (e) { return {}; } }
  function write(k, patch) {
    var s = read(k);
    for (var p in patch) { if (Object.prototype.hasOwnProperty.call(patch, p)) s[p] = patch[p]; }
    try { window.localStorage.setItem(k, JSON.stringify(s)); } catch (e) {}
    return s;
  }
  function cookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|;\\s*)' + name + '=([^;]*)'));
    return m ? m[1] : '';
  }
  function loadFonts() {
    if (document.getElementById('lp-tab15-fonts')) return;
    var l = document.createElement('link');
    l.id = 'lp-tab15-fonts';
    l.rel = 'stylesheet';
    l.href = FONTS;
    document.head.appendChild(l);
  }
  function smSignedUp() {
    try {
      for (var i = 0; i < window.localStorage.length; i++) {
        var k = window.localStorage.key(i);
        if (k && k.indexOf('_smwesform-') === 0) return true;
      }
    } catch (e) {}
    return false;
  }
  function clearTimers(id) {
    var t = timers[id];
    if (!t) return;
    for (var i = 0; i < t.length; i++) { clearInterval(t[i]); clearTimeout(t[i]); }
    if (t.scroll) window.removeEventListener('scroll', t.scroll);
    delete timers[id];
  }

  function init(root) {
    if (!root || root.__lpTab15) return;
    root.__lpTab15 = true;

    var cfg;
    try { cfg = JSON.parse(root.querySelector('[data-lp-tab15-cfg]').textContent); } catch (e) { return; }
    var id = cfg.id || 'x';
    var KEY = 'lp_tab15:' + (cfg.key || id);
    var tab = root.querySelector('[data-lp-tab15-tab]');
    var openBtn = root.querySelector('[data-lp-tab15-open]');
    var xBtn = root.querySelector('[data-lp-tab15-x]');
    var ov = root.querySelector('.lp-tab15-ov');
    var formBox = root.querySelector('[data-lp-tab15-form]');
    var isLink = cfg.mode === 'link';
    if (!tab || !openBtn || (!ov && !isLink)) return;

    clearTimers(id);
    var T = timers[id] = [];
    function later(fn, ms) { var h = setTimeout(fn, ms); T.push(h); return h; }

    // Zakładkę i okienko przenosimy pod <body> (z kolorami/rozmiarami sekcji), żeby kontener motywu
    // z transform/overflow nie psuł position:fixed. Kontener formularza przenosi się razem z okienkiem.
    var portal = document.createElement('div');
    portal.className = 'lp-tab15-portal';
    portal.setAttribute('data-section-id', id);
    portal.setAttribute('style', root.getAttribute('style') || '');
    if (ov) portal.appendChild(ov);
    portal.appendChild(tab);
    document.body.appendChild(portal);

    var preview = cfg.preview && cfg.preview !== 'none';
    var hideMs = Math.max(1, cfg.hideDays || 14) * DAY;
    var submitted = false;

    // --- wizyta (przerwa >= 30 min = nowa wizyta)
    var now = Date.now();
    var s0 = read(KEY);
    var newVisit = !s0.last || now - s0.last > VISIT_GAP;
    var visitStart = newVisit ? now : (s0.visitStart || now);
    write(KEY, { last: now, visitStart: visitStart });

    function blocked() {
      if (preview) return '';
      var s = read(KEY);
      if (s.signed) return 'zapisany';
      if (cfg.hideSignup && smSignedUp()) return 'zapisany-sm';
      if (s.until && Date.now() < s.until) return 'ukryty-do';
      if (cfg.hideAfterDialogClose && s.hideVisit && s.hideVisit === visitStart) return 'zamknieto-okienko';
      if (cfg.hideSmKnown && cookie('smclient')) return 'znany-w-sm';
      if (cfg.hideBuyer && (lsGet('lp_buyer') || cookie('lp_buyer'))) return 'kupujacy';
      if (cfg.trigger === 'after_popup' && !read(SM_KEY).closed && !fallbackOk) return 'pop-up-nie-zamkniety';
      return '';
    }
    var FINAL = { 'zapisany': 1, 'zapisany-sm': 1, 'ukryty-do': 1, 'znany-w-sm': 1, 'kupujacy': 1 };
    var fallbackOk = false;

    // --- limit wizyt bez kliknięcia: liczymy wizyty, w których zakładka była widoczna
    var countedThisVisit = false;
    function countVisit() {
      if (preview || countedThisVisit || !cfg.maxVisits) return true;
      var s = read(KEY);
      if (s.countedVisit === visitStart) { countedThisVisit = true; return true; }
      if ((s.visits || 0) >= cfg.maxVisits) {
        write(KEY, { until: Date.now() + hideMs, visits: 0 });
        return false;
      }
      write(KEY, { visits: (s.visits || 0) + 1, countedVisit: visitStart });
      countedThisVisit = true;
      return true;
    }

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var touch = window.matchMedia && window.matchMedia('(hover: none), (max-width: 767px)').matches;
    var peeked = false;
    // telefon: krótkie rozwinięcie (2,5 s) raz na wizytę — sessionStorage żyje do zamknięcia karty
    function peekedThisVisit() {
      var k = 'lp_tab15_peek:' + (cfg.key || id);
      try {
        if (window.sessionStorage.getItem(k) === '1') return true;
        window.sessionStorage.setItem(k, '1');
      } catch (e) {}
      return false;
    }

    var smOpen = false;
    function showTab() {
      if (smOpen) return;
      if (ov && ov.classList.contains('is-on')) return;
      var why = blocked();
      if (why) { hideTab(); if (FINAL[why]) stopWatching(); return; }
      if (!countVisit()) { hideTab(); stopWatching(); return; }
      tab.classList.add('is-on');
      tab.inert = false;
      tab.removeAttribute('aria-hidden');
      if (cfg.fonts && !isLink) loadFonts();
      if (ov) {
        var im = ov.querySelector('img[loading="lazy"]');
        if (im) im.loading = 'eager';
      }
      if (cfg.peek && touch && !reduce && !peeked && tab.classList.contains('lp-tab15--strip')) {
        peeked = true;
        if (preview || !peekedThisVisit()) {
          later(function () { tab.classList.add('is-peek'); }, 500);
          later(function () { tab.classList.remove('is-peek'); }, 3000);
        }
      }
    }
    function hideTab() {
      tab.classList.remove('is-on', 'is-peek');
      tab.inert = true;
      tab.setAttribute('aria-hidden', 'true');
    }
    hideTab();

    var prevFocus = null;
    var htmlDone = false;
    // tryb „Własny HTML”: kod z <template> wstawiamy dopiero przy pierwszym otwarciu (ramki/skrypty nie ładują się na każdej podstronie)
    function mountHtml() {
      if (htmlDone || !ov) return;
      var tpl = ov.querySelector('template[data-lp-tab15-html]');
      if (!tpl) return;
      htmlDone = true;
      var frag = document.importNode(tpl.content, true);
      var scripts = frag.querySelectorAll('script');
      for (var i = 0; i < scripts.length; i++) {
        var old = scripts[i], sc = document.createElement('script');
        for (var a = 0; a < old.attributes.length; a++) sc.setAttribute(old.attributes[a].name, old.attributes[a].value);
        sc.text = old.textContent;
        old.parentNode.replaceChild(sc, old);
      }
      tpl.parentNode.replaceChild(frag, tpl);
    }
    function openDialog() {
      prevFocus = document.activeElement;
      mountHtml();
      if (cfg.fonts) loadFonts();
      write(KEY, { clicked: Date.now(), visits: 0 });
      hideTab();
      ov.hidden = false;
      ov.classList.add('is-on');
      openBtn.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('lp-tab15-lock');
      var c = ov.querySelector('[data-lp-tab15-close]');
      if (c) c.focus();
    }
    function closeDialog() {
      ov.classList.remove('is-on');
      ov.hidden = true;
      openBtn.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('lp-tab15-lock');
      if (submitted || (cfg.hideSignup && smSignedUp())) { write(KEY, { signed: true }); hideTab(); stopWatching(); restoreFocus(); return; }
      if (cfg.hideAfterDialogClose && !preview) { write(KEY, { hideVisit: visitStart }); hideTab(); restoreFocus(); return; }
      later(function () {
        showTab();
        if (tab.classList.contains('is-on')) { try { openBtn.focus({ preventScroll: true }); } catch (e) {} } else restoreFocus();
      }, 250);
    }
    // po zamknięciu: fokus na element aktywny przed otwarciem (o ile widoczny), inaczej na <body>
    function restoreFocus() {
      var p = prevFocus;
      prevFocus = null;
      if (p && p !== openBtn && p !== document.body && document.contains(p) && p.offsetParent !== null) {
        try { p.focus({ preventScroll: true }); return; } catch (e) {}
      }
      if (document.activeElement && document.activeElement !== document.body && document.activeElement.blur) document.activeElement.blur();
    }

    if (isLink) {
      openBtn.addEventListener('click', function () { if (!preview) write(KEY, { clicked: Date.now(), visits: 0 }); });
    } else {
      openBtn.addEventListener('click', openDialog);
      ov.addEventListener('click', function (e) {
        if (e.target === ov || (e.target.closest && e.target.closest('[data-lp-tab15-close]'))) closeDialog();
        else if (e.target.closest && e.target.closest('[data-lp-tab15-cta]')) write(KEY, { clicked: Date.now() });
      });
      document.addEventListener('keydown', function (e) {
        if (!ov.classList.contains('is-on')) return;
        if (e.key === 'Escape') { closeDialog(); return; }
        if (e.key !== 'Tab') return;
        // pułapka fokusu w okienku
        var list = ov.querySelectorAll('button, input, select, textarea, iframe, a[href], [tabindex]:not([tabindex="-1"])');
        var f = [];
        for (var i = 0; i < list.length; i++) { if (list[i].offsetParent !== null && !list[i].disabled) f.push(list[i]); }
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1], a = document.activeElement;
        if (!ov.contains(a)) { e.preventDefault(); first.focus(); }
        else if (e.shiftKey && a === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && a === last) { e.preventDefault(); first.focus(); }
      });
      if (formBox) formBox.addEventListener('submit', function () { submitted = true; }, true);
    }
    if (xBtn) {
      xBtn.addEventListener('click', function () {
        if (!preview) write(KEY, { until: Date.now() + hideMs, visits: 0 });
        hideTab();
        stopWatching();
        restoreFocus();
      });
    }

    // --- podgląd w edytorze motywu
    if (preview) {
      if (cfg.preview === 'dialog' && ov) openDialog(); else showTab();
      return;
    }

    // --- obserwacja pop-upu SALESmanago: gdy jest otwarty — zakładka schowana; gdy zniknie — zapamiętujemy „zamknięty”
    var sel = cfg.popupSelector || '#bhr-items [id^="wes-"]';
    var smSeen = false;
    function smIsOpen() { try { return !!document.querySelector(sel); } catch (e) { return false; } }
    var watcher = setInterval(function () {
      var open = smIsOpen();
      if (open && !smOpen) { smOpen = true; smSeen = true; hideTab(); }
      if (!open && smOpen) {
        smOpen = false;
        write(SM_KEY, { closed: true });
        if (cfg.trigger === 'after_popup' || started) later(showTab, Math.max(500, (cfg.delay || 0) * 1000));
      }
    }, 500);
    T.push(watcher);
    // trwale ukryta lub zapisana → przestajemy sprawdzać co 0,5 s
    function stopWatching() {
      if (preview) return;
      clearInterval(watcher);
      if (T.scroll) { window.removeEventListener('scroll', T.scroll); T.scroll = null; }
    }

    // --- start wg ustawienia „Zakładka pojawia się”
    var started = false;
    function start() { started = true; showTab(); }
    if (cfg.trigger === 'scroll') {
      var need = Math.min(100, Math.max(0, cfg.scrollPct || 0)) / 100;
      var onScroll = function () {
        var h = document.documentElement.scrollHeight - window.innerHeight;
        var done = h <= 0 ? 1 : window.scrollY / h;
        if (done >= need) { window.removeEventListener('scroll', onScroll); T.scroll = null; start(); }
      };
      T.scroll = onScroll;
      window.addEventListener('scroll', onScroll, { passive: true });
      later(onScroll, 300);
    } else if (cfg.trigger === 'after_popup') {
      if (read(SM_KEY).closed) later(start, Math.max(300, (cfg.delay || 0) * 1000));
      else if (cfg.popupFallback > 0) {
        // zapas: pop-up SM nie pojawił się przez N s od wejścia (np. zamknięty przed wdrożeniem albo limit wyświetleń) → zakładka i tak się pokazuje
        later(function () {
          if (smSeen || smIsOpen()) return;
          fallbackOk = true;
          start();
        }, cfg.popupFallback * 1000);
      }
    } else {
      later(start, Math.max(300, (cfg.delay || 0) * 1000));
    }
  }

  function boot() {
    var roots = document.querySelectorAll('[data-lp-tab15]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  // Edytor motywu: po zmianie ustawień sekcja renderuje się od nowa — usuwamy TYLKO jej portal i startujemy jeszcze raz
  function dropPortal(e) {
    var sid = e && e.detail && e.detail.sectionId;
    var old = document.querySelectorAll('body > .lp-tab15-portal');
    for (var i = 0; i < old.length; i++) {
      if (!sid || old[i].getAttribute('data-section-id') === sid) {
        clearTimers(old[i].getAttribute('data-section-id'));
        old[i].parentNode.removeChild(old[i]);
      }
    }
    document.documentElement.classList.remove('lp-tab15-lock');
  }
  document.addEventListener('shopify:section:load', function (e) { dropPortal(e); boot(); });
  document.addEventListener('shopify:section:unload', dropPortal);
})();
